import type { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';
import { ILocationProvider } from 'angular';

import { configureReportRoutes } from './report.routes';

function configReportViewerRoutes(
  $locationProvider: ILocationProvider,
  $stateProvider: StateProvider,
  $urlRouterProvider: UrlRouterProvider
) {
  // Requires rewrite rules
  $locationProvider.html5Mode({ enabled: true, requireBase: false });

  // Strip trailing / if it exists on URL
  $urlRouterProvider.rule((_, $location) => {
    const path = $location.path();
    if (path !== '/' && path.slice(-1) === '/') {
      return path.slice(0, -1);
    }
  });

  $urlRouterProvider.deferIntercept();
  configureReportRoutes($stateProvider, $urlRouterProvider);
}

export const reportViewerRouteConfig = [
  '$locationProvider',
  '$stateProvider',
  '$urlRouterProvider',
  '$provide',
  configReportViewerRoutes,
];
